
import React from 'react';
import { useSelector } from 'react-redux';

import {
    getUsekMezItems,
} from '../../reducers/project';

import UsekSelectorView from './UsekSelector.view';

const UsekSelectorState = ({
    onChange,
    usekId
}) => {

    const usekMezItems = useSelector(state => getUsekMezItems(state.project));

    const handleUsekChange = (selectedUsekId) => {
        if (onChange) {
            onChange(selectedUsekId);
        }
    }

    return (
        <>
            <UsekSelectorView
                onChange={handleUsekChange}
                usekId={usekId}
                usekMezItems={usekMezItems}
            />
        </>
    )
}

export default UsekSelectorState;
